import type { AccountInfo } from '@azure/msal-browser'
import { CanceledError } from 'axios'
import { z } from 'zod'

import { apiClient } from '../../config/axios-client'

export const currentUserInfosSchema = z.object({
  claims: z.array(z.object({ type: z.string().min(1), value: z.string().min(1) })),
  roleOverrideActive: z.boolean(),
})

export type CurrentUserInfos = z.infer<typeof currentUserInfosSchema>

export const usersApi = {
  current: async (account: AccountInfo, signal: AbortSignal): Promise<CurrentUserInfos> => {
    const response = await apiClient.get<unknown>('users/me/infos', {
      authAccount: account,
      signal,
    })
    if (signal.aborted) {
      throw new CanceledError()
    }

    return currentUserInfosSchema.parse(response.data)
  },
}
